import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import { ChatFormValues } from '../config/types/ChatForm';
import { useChatMessagesContext } from '../context/chatMessages';

export const useClearChatForm = () => {
  const methods = useFormContext<ChatFormValues>();

  const { setParentMessage, setEditedMessage } = useChatMessagesContext();

  return useCallback(() => {
    setParentMessage(null);
    setEditedMessage(null);
    methods.reset();
    methods.setFocus('text');
  }, [methods, setParentMessage, setEditedMessage]);
};
